import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CloudOff, RefreshCw } from "lucide-react";
import { flushOffline, offlineQueue } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function OfflineBanner() {
  const { user, reload } = useApp();
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(offlineQueue().length);
  useEffect(() => {
    const sync = async () => {
      setOnline(navigator.onLine);
      if (!navigator.onLine || !offlineQueue().length) return;
      const n = await flushOffline();
      if (n) { toast.success(`${n} offline change${n === 1 ? "" : "s"} synced`); reload(); window.dispatchEvent(new Event("mwjk-synced")); }
    };
    const count = () => setPending(offlineQueue().length);
    const off = () => setOnline(false);
    window.addEventListener("online", sync);
    window.addEventListener("offline", off);
    window.addEventListener("mwjk-queue", count);
    if (user) { sync(); }
    return () => { window.removeEventListener("online", sync); window.removeEventListener("offline", off); window.removeEventListener("mwjk-queue", count); };
  }, [user, reload]);
  if (online && !pending) return null;
  return (
    <div className="no-print flex items-center gap-2 bg-amber-100 px-4 py-2 text-sm font-semibold text-amber-900" data-testid="offline-banner">
      {online ? <RefreshCw className="h-4 w-4 animate-spin" /> : <CloudOff className="h-4 w-4" />}
      {online ? `Syncing ${pending} saved change${pending === 1 ? "" : "s"}...` : `You are offline. Showing saved data.${pending ? ` ${pending} change${pending === 1 ? "" : "s"} will sync when you're back online.` : " New tithes, conference collections, progress reports and registrations will be saved and synced later."}`}
    </div>
  );
}
